/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages401,
  GetApiV1LocationCountriesCountryidLangsAvailableLanguages500,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangsAvailableLanguages.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCountriesCountryidLangsAvailableLanguages } from "../../clients/locationCountryLangController/getApiV1LocationCountriesCountryidLangsAvailableLanguages.ts";

export const getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey =
  (
    countryId: GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams["countryId"],
  ) =>
    [
      {
        url: "/api/v1/location/countries/:countryId/langs/available-languages",
        params: { countryId: countryId },
      },
    ] as const;

export type GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey =
  ReturnType<
    typeof getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey
  >;

export function getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryOptions(
  countryId: GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams["countryId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey(
      countryId,
    );
  return queryOptions<
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages401
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages500
    >,
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
    typeof queryKey
  >({
    enabled: !!countryId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCountriesCountryidLangsAvailableLanguages(
        countryId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna as culturas ainda não cadastradas para o país informado. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/available-languages}
 */
export function useGetApiV1LocationCountriesCountryidLangsAvailableLanguages<
  TData =
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
  TQueryData =
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey,
>(
  countryId: GetApiV1LocationCountriesCountryidLangsAvailableLanguagesPathParams["countryId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1LocationCountriesCountryidLangsAvailableLanguages401
          | GetApiV1LocationCountriesCountryidLangsAvailableLanguages500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryKey(
      countryId,
    );

  const query = useQuery(
    {
      ...getApiV1LocationCountriesCountryidLangsAvailableLanguagesQueryOptions(
        countryId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages401
      | GetApiV1LocationCountriesCountryidLangsAvailableLanguages500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
